import { render, staticRenderFns } from "./caracteristics.vue?vue&type=template&id=2324e1dd&scoped=true"
import script from "./caracteristics.vue?vue&type=script&lang=js"
export * from "./caracteristics.vue?vue&type=script&lang=js"
import style0 from "./caracteristics.vue?vue&type=style&index=0&id=2324e1dd&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2324e1dd",
  null
  
)

export default component.exports